/* eslint-disable no-param-reassign */
export default {
  state: {
    reiniciar: null,
    accion: null,
    mensajeChatBox: null,
    cedulaPaciente: null,
    nombrePaciente: null,
    inicioChat: null,
    encuentro: null,
    encuentroOverlay: null,
    formularios: null,
    nombreFormulario: null,
    nombreFormularioInfoGeneral: null,
    nombreFormularioOverlay: null,
    nombreCampo: null,
    nombreCampoInfoGeneral: null,
    nombreCampoOverlay: null,
    fallback: null,
    campoIngresado: null,
    campoIngresadoInfoGeneral: null,
    campoIngresadoOverlay: null,
    escogerEvento: null,
    idFormulario: null,
    idFormularioInfoGeneral: null,
    idFormularioOverlay: null,
    verAgenda: null,
    siguiente: null,
    logHistoriaClinica: null,
    resumenHC: null,
    especificoHC: null,
    nombreFormularioEspecifico: null,
    numeroCampo: null,
    checkpoint: null,
    campoVacio: null,
  },
  getters: {
    getIdFormularioOverlay: state => state.idFormularioOverlay,
    getVariableByName: state => (name) => state[name],
    getReiniciar: state => state.reiniciar,
    getAccion: state => state.accion,
    getMensajeChatBox: state => state.mensajeChatBox,
    getCedulaPaciente: state => state.cedulaPaciente,
    getNombrePaciente: state => state.nombrePaciente,
    getInicioChat: state => state.inicioChat,
    getEncuentro: state => state.encuentro,
    getEncuentroOverlay: state => state.encuentroOverlay,
    getFormularios: state => state.formularios,
    getNombreFormulario: state => state.nombreFormulario,
    getNombreFormularioInfoGeneral: state => state.nombreFormularioInfoGeneral,
    getNombreFormularioOverlay: state => state.nombreFormularioOverlay,
    getNombreCampo: state => state.nombreCampo,
    getNombreCampoInfoGeneral: state => state.nombreCampoInfoGeneral,
    getNombreCampoOverlay: state => state.nombreCampoOverlay,
    getFallback: state => state.fallback,
    getCampoIngresado: state => state.campoIngresado,
    getCampoIngresadoInfoGeneral: state => state.campoIngresadoInfoGeneral,
    getCampoIngresadoOverlay: state => state.campoIngresadoOverlay,
    getEscogerEvento: state => state.escogerEvento,
    getIdFormulario: state => state.idFormulario,
    getIdFormularioInfoGeneral: state => state.idFormularioInfoGeneral,
    getVerAgenda: state => state.verAgenda,
    getSiguiente: state => state.siguiente,
    getLogHistoriaClinica: state => state.logHistoriaClinica,
    getResumenHC: state => state.resumenHC,
    getEspecificoHC: state => state.especificoHC,
    getNombreFormularioEspecifico: state => state.nombreFormularioEspecifico,
    getNumeroCampo: state => state.numeroCampo,
    getTipoCampo: state => state.tipoCampo,
    getCheckpoint: state => state.checkpoint,
    getCampoVacio: state => state.campoVacio,
  },
  mutations: {
    setIdFormularioOverlay(state, valor) {
      state.idFormularioOverlay = valor;
    },
    setReiniciar(state, estado) {
      state.reiniciar = estado;
    },
    setAccion(state, valor) {
      state.accion = valor;
    },
    setMensajeChatBox(state, mensaje) {
      state.mensajeChatBox = mensaje;
    },
    setCedulaPaciente(state, valor) {
      state.cedulaPaciente = valor;
    },
    setNombrePaciente(state, valor) {
      state.nombrePaciente = valor;
    },
    setInicioChat(state, valor) {
      state.inicioChat = valor;
    },
    setEncuentro(state, valor) {
      state.encuentro = valor;
    },
    setEncuentroOverlay(state, valor) {
      state.encuentroOverlay = valor;
    },
    setFormularios(state, valor) {
      state.formularios = valor;
    },
    setNombreFormulario(state, valor) {
      state.nombreFormulario = valor;
    },
    setNombreFormularioInfoGeneral(state, valor) {
      state.nombreFormularioInfoGeneral = valor;
    },
    setNombreCampo(state, valor) {
      state.nombreCampo = valor;
    },
    setNombreFormularioOverlay(state, valor) {
      state.nombreFormularioOverlay = valor;
    },
    setNombreCampoInfoGeneral(state, valor) {
      state.nombreCampoInfoGeneral = valor;
    },
    setNombreCampoOverlay(state, valor) {
      state.nombreCampoOverlay = valor;
    },
    setFallback(state, valor) {
      state.fallback = valor;
    },
    setCampoIngresado(state, valor) {
      state.campoIngresado = valor;
    },
    setCampoIngresadoInfoGeneral(state, valor) {
      state.campoIngresadoInfoGeneral = valor;
    },
    setCampoIngresadoOverlay(state, valor) {
      state.campoIngresadoOverlay = valor;
    },
    setEscogerEvento(state, valor) {
      state.escogerEvento = valor;
    },
    setIdFormulario(state, valor) {
      state.idFormulario = valor;
    },
    setIdFormularioInfoGeneral(state, valor) {
      state.idFormularioInfoGeneral = valor;
    },
    setVerAgenda(state, valor) {
      state.verAgenda = valor;
    },
    setSiguiente(state, valor) {
      state.siguiente = valor;
    },
    setLogHistoriaClinica(state, valor) {
      state.logHistoriaClinica = valor;
    },
    setResumenHC(state, valor) {
      state.resumenHC = valor;
    },
    setEspecificoHC(state, valor) {
      state.especificoHC = valor;
    },
    setNombreFormularioEspecifico(state, valor) {
      state.nombreFormularioEspecifico = valor;
    },
    setNumeroCampo(state, valor) {
      state.numeroCampo = valor;
    },
    setCheckpoint(state, valor) {
      state.checkpoint = valor;
    },
    setTipoCampo(state, valor) {
      state.tipoCampo = valor;
    },
    setCampoVacio(state, valor) {
      state.campoVacio = valor;
    },
  },
  actions: {
    setIdFormularioOverlay(context, valor) {
      context.commit('setIdFormularioOverlay', valor);
    },
    setReiniciar(context, estado) {
      context.commit('setReiniciar', estado);
    },
    setAccion(context, valor) {
      context.commit('setAccion', valor);
    },
    setMensajeChatBox(context, mensaje) {
      context.commit('setMensajeChatBox', mensaje);
    },
    setCedulaPaciente(context, valor) {
      context.commit('setCedulaPaciente', valor);
    },
    setNombrePaciente(context, valor) {
      context.commit('setNombrePaciente', valor);
    },
    setInicioChat(context, valor) {
      context.commit('setInicioChat', valor);
    },
    setEncuentro(context, valor) {
      context.commit('setEncuentro', valor);
    },
    setEncuentroOverlay(context, valor) {
      context.commit('setEncuentroOverlay', valor);
    },
    setFormularios(context, valor) {
      context.commit('setFormularios', valor);
    },
    setNombreFormulario(context, valor) {
      context.commit('setNombreFormulario', valor);
    },
    setNombreFormularioInfoGeneral(context, valor) {
      context.commit('setNombreFormularioInfoGeneral', valor);
    },
    setNombreFormularioOverlay(context, valor) {
      context.commit('setNombreFormularioOverlay', valor);
    },
    setNombreFormulario3(context, valor) {
      context.commit('setNombreFormulario3', valor);
    },
    setNombreCampo(context, valor) {
      context.commit('setNombreCampo', valor);
    },
    setNombreCampoInfoGeneral(context, valor) {
      context.commit('setNombreCampoInfoGeneral', valor);
    },
    setNombreCampoOverlay(context, valor) {
      context.commit('setNombreCampoOverlay', valor);
    },
    setFallback(context, valor) {
      context.commit('setFallback', valor);
    },
    setCampoIngresado(context, valor) {
      context.commit('setCampoIngresado', valor);
    },
    setCampoIngresadoInfoGeneral(context, valor) {
      context.commit('setCampoIngresadoInfoGeneral', valor);
    },
    setCampoIngresadoOverlay(context, valor) {
      context.commit('setCampoIngresadoOverlay', valor);
    },
    setEscogerEvento(context, valor) {
      context.commit('setEscogerEvento', valor);
    },
    setIdFormulario(context, valor) {
      context.commit('setIdFormulario', valor);
    },
    setIdFormularioInfoGeneral(context, valor) {
      context.commit('setIdFormularioInfoGeneral', valor);
    },
    setVerAgenda(context, valor) {
      context.commit('setVerAgenda', valor);
    },
    setSiguiente(context, valor) {
      context.commit('setSiguiente', valor);
    },
    setLogHistoriaClinica(context, valor) {
      context.commit('setLogHistoriaClinica', valor);
    },
    setResumenHC(context, valor) {
      context.commit('setResumenHC', valor);
    },
    setEspecificoHC(context, valor) {
      context.commit('setEspecificoHC', valor);
    },
    setNombreFormularioEspecifico(context, valor) {
      context.commit('setNombreFormularioEspecifico', valor);
    },
    setNumeroCampo(context, valor) {
      context.commit('setNumeroCampo', valor);
    },
    setCheckpoint(context, valor) {
      context.commit('setCheckpoint', valor);
    },
    setTipoCampo(context, valor) {
      context.commit('setTipoCampo', valor);
    },
    setCampoVacio(context, valor) {
      context.commit('setCampoVacio', valor);
    },
  },
};



// WEBPACK FOOTER //
// ./src/js/modules/ChatBox.js